import { render, staticRenderFns } from "./FeatureTable.vue?vue&type=template&id=a237485c&scoped=true"
import script from "./FeatureTable.vue?vue&type=script&lang=js"
export * from "./FeatureTable.vue?vue&type=script&lang=js"
import style0 from "./FeatureTable.vue?vue&type=style&index=0&id=a237485c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a237485c",
  null
  
)

export default component.exports